import ping from './pingEpic'
import pong from './pongEpic'
import { combineEpics } from 'redux-observable'

export default combineEpics(ping, pong)



/** WEBPACK FOOTER **
 ** ./src/epics/index.js
 **/